import React, { Component } from 'react';

class ScoreEntry extends Component {

    displayUsername () {
        if (this.props.name === undefined) {
            return null
        } else return <a href={`https://twitter.com/${this.props.name}`}>@{this.props.name}</a>
    }

    render() {
        return (
            <li className="score-entry">
                <div className="rank">
                    <div className="place">{this.props.rank}</div>
                </div>
                <div className="name">{this.displayUsername()}</div>
                <div className="scored">{(this.props.score).toLocaleString()}</div>
            </li>
        );
    }
}

export default ScoreEntry;


// WEBPACK FOOTER //
// ./src/components/ScoreEntry.js